document.addEventListener('DOMContentLoaded', function () {
  function personaliseButton() {
    document.querySelector('.personalise-button')?.addEventListener('click', function () {
      document.querySelector('.personalise-button').style.display = 'none';
      document.querySelector('.buy-buttons').style.display = 'block';
    });
  }
  
  let savedFirstName = '';
  let savedLastName = '';

  function initCustomNameFields() {
    const firstName = document.getElementById('first-name');
    const lastName = document.getElementById('last-name');
    const firstNameOutput = document.getElementById('live-first-name');
    const lastNameOutput = document.getElementById('live-last-name');
    const firstNameError = document.getElementById('first-name-error');
    const lastNameError = document.getElementById('last-name-error');
    const customButton = document.querySelector('.product-form__submit.custom-atc-button');
    const defaultButton = document.querySelector('.product-form__submit:not(.custom-atc-button)');
    const defaultBuyButton = document.querySelector('#gokwik-buy-now');

    if (!firstName || !lastName || !customButton || !defaultButton) return;

    // Restore saved values after variant change
    firstName.value = savedFirstName;
    lastName.value = savedLastName;

    if (firstNameOutput) firstNameOutput.textContent = savedFirstName;
    if (lastNameOutput) lastNameOutput.textContent = savedLastName;

    firstName.addEventListener('input', function () {
      savedFirstName = firstName.value;
      if (firstNameOutput) firstNameOutput.textContent = firstName.value;
      if (firstName.value.trim()) {
        if (firstNameError) firstNameError.textContent = '';
        firstName.classList.remove('input-error');
      }
      toggleButtons();
    });

    lastName.addEventListener('input', function () {
      savedLastName = lastName.value;
      if (lastNameOutput) lastNameOutput.textContent = lastName.value;
      if (lastName.value.trim()) {
        if (lastNameError) lastNameError.textContent = '';
        lastName.classList.remove('input-error');
      }
      toggleButtons();
    });

    function toggleButtons() {
      const firstFilled = firstName.value.trim() !== '';
      const lastFilled = lastName.value.trim() !== '';

      if (firstFilled && lastFilled) {
        if (customButton) customButton.style.display = 'none';
        if (defaultButton) defaultButton.style.display = 'block';
        if (defaultBuyButton) defaultBuyButton.style.display = 'block';
      } else {
        if (customButton) customButton.style.display = 'block';
        if (defaultButton) defaultButton.style.display = 'none';
        if (defaultBuyButton) defaultBuyButton.style.display = 'none';
      }
    }

    // Initial state
    toggleButtons();

    // Custom button click validation
    customButton.addEventListener('click', function (e) {
      let isValid = true;

      if (!firstName.value.trim()) {
        if (firstNameError) firstNameError.textContent = 'Full name is required.';
        firstName.classList.add('input-error');
        isValid = false;
      }

      if (!lastName.value.trim()) {
        if (lastNameError) lastNameError.textContent = 'First name is required.';
        lastName.classList.add('input-error');
        isValid = false;
      }

      if (isValid && defaultButton) {
        e.preventDefault();
        defaultButton.click();
      }
    });
  }

  // Initial load
  initCustomNameFields();
  personaliseButton();

  // Re-initialize on variant change
  document.addEventListener('product:variant:changed', function () {
    initCustomNameFields(); // Will restore saved values
    personaliseButton();
  });

  document.addEventListener('product:quick:add', function () {
    initCustomNameFields(); // Will restore saved values
    personaliseButton();
  });
});